import { createContext, useContext, useEffect, useState } from "react";

const LANG_KEY = "arslan_lang";
export const LANGS = [
  { code: "tr", label: "Türkçe", short: "TR" },
  { code: "en", label: "English", short: "EN" },
  { code: "ro", label: "Română", short: "RO" },
];

export const translations = {
  tr: {
    "app.subtitle": "FİNANS YÖNETİMİ",
    // nav
    "nav.dashboard": "Nakit Akışı",
    "nav.transactions": "Gelir / Gider",
    "nav.accounts": "Banka Hesapları",
    "nav.contacts": "Cari Hesaplar",
    "nav.customers": "Müşteriler",
    "nav.suppliers": "Tedarikçiler",
    "nav.notes": "Müşteri Notları",
    "nav.stock": "Stok",
    "nav.products": "Ürün Listesi",
    "nav.orders": "Sipariş Gir",
    "nav.cost": "Maliyet",
    "nav.payments": "Ödeme / Tahsilat",
    "nav.reports": "Raporlar",
    "nav.assistant": "Finansal Asistan",
    "nav.import": "Veri Güncelle",
    "nav.personnel": "Personel",
    "nav.audit": "İşlem Logu",
    // common
    "common.language": "Dil",
    "common.logout": "Çıkış Yap",
    "common.changePassword": "Şifre Değiştir",
    // login
    "login.subtitle": "Finans yönetim panelinize giriş yapın",
    "login.email": "E-posta",
    "login.password": "Şifre",
    "login.submit": "Giriş Yap",
    "login.forgot": "Şifremi unuttum?",
    "login.error": "Bir hata oluştu. Lütfen tekrar deneyin.",
    "dash.period": "Dönem",
    "dash.overview": "finansal genel görünüm",
    "dash.netPosition": "Net Pozisyon",
    "dash.bankAccounts": "banka hesabı",
    "dash.income": "Gelir",
    "dash.expense": "Gider",
    "dash.netCashflow": "Net Nakit Akışı",
    "dash.monthlyCashflow": "Aylık Nakit Akışı",
    "dash.last6": "Son 6 ay · gelir / gider",
    "dash.expenseDist": "Gider Dağılımı",
    "dash.thisMonthCat": "Bu ay · kategori bazlı",
    "dash.noExpense": "Bu ay gider kaydı yok",
    "dash.aiTitle": "AI Finansal Analiz",
    "dash.aiSub": "Yapay zeka destekli içgörüler",
    "dash.analyze": "Analiz Et",
    "dash.analyzing": "Verileriniz analiz ediliyor...",
    "dash.aiPrompt": "Nakit akışınız hakkında akıllı öneriler almak için \"Analiz Et\" butonuna tıklayın.",
    "dash.aiFail": "AI analizi başarısız oldu",
    "dash.upcoming": "Yaklaşan Ödeme / Tahsilat",
    "dash.pending": "bekleyen işlem",
    "dash.noPending": "Bekleyen işlem yok",
    "dash.daysLate": "gün gecikti",
    "dash.today": "Bugün",
    "dash.daysLeft": "gün kaldı",
    "dash.mamulTitle": "Mamül Satış Panosu",
    "dash.mamulSub": "Ürün bazında toplam satış adedi ve cirosu",
    "dash.noMamul": "Satışı olan mamül bulunamadı",
    "dash.unit": "adet",
  },
  en: {
    "app.subtitle": "FINANCE MANAGEMENT",
    "nav.dashboard": "Cash Flow",
    "nav.transactions": "Income / Expense",
    "nav.accounts": "Bank Accounts",
    "nav.contacts": "Accounts (Partners)",
    "nav.customers": "Customers",
    "nav.suppliers": "Suppliers",
    "nav.notes": "Customer Notes",
    "nav.stock": "Stock",
    "nav.products": "Product List",
    "nav.orders": "New Order",
    "nav.cost": "Cost",
    "nav.payments": "Payments / Receipts",
    "nav.reports": "Reports",
    "nav.assistant": "Financial Assistant",
    "nav.import": "Data Update",
    "nav.personnel": "Personnel",
    "nav.audit": "Audit Log",
    "common.language": "Language",
    "common.logout": "Sign Out",
    "common.changePassword": "Change Password",
    "login.subtitle": "Sign in to your finance panel",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign In",
    "login.forgot": "Forgot password?",
    "login.error": "An error occurred. Please try again.",
    "dash.period": "Period",
    "dash.overview": "financial overview",
    "dash.netPosition": "Net Position",
    "dash.bankAccounts": "bank accounts",
    "dash.income": "Income",
    "dash.expense": "Expense",
    "dash.netCashflow": "Net Cash Flow",
    "dash.monthlyCashflow": "Monthly Cash Flow",
    "dash.last6": "Last 6 months · income / expense",
    "dash.expenseDist": "Expense Breakdown",
    "dash.thisMonthCat": "This month · by category",
    "dash.noExpense": "No expenses this month",
    "dash.aiTitle": "AI Financial Analysis",
    "dash.aiSub": "AI-powered insights",
    "dash.analyze": "Analyze",
    "dash.analyzing": "Analyzing your data...",
    "dash.aiPrompt": "Click \"Analyze\" to get smart suggestions about your cash flow.",
    "dash.aiFail": "AI analysis failed",
    "dash.upcoming": "Upcoming Payments / Receipts",
    "dash.pending": "pending items",
    "dash.noPending": "No pending items",
    "dash.daysLate": "days overdue",
    "dash.today": "Today",
    "dash.daysLeft": "days left",
    "dash.mamulTitle": "Finished Goods Sales",
    "dash.mamulSub": "Total sold quantity and turnover per product",
    "dash.noMamul": "No finished goods with sales",
    "dash.unit": "units",
  },
  ro: {
    "app.subtitle": "MANAGEMENT FINANCIAR",
    "nav.dashboard": "Flux de Numerar",
    "nav.transactions": "Venituri / Cheltuieli",
    "nav.accounts": "Conturi Bancare",
    "nav.contacts": "Conturi Parteneri",
    "nav.customers": "Clienți",
    "nav.suppliers": "Furnizori",
    "nav.notes": "Note Clienți",
    "nav.stock": "Stoc",
    "nav.products": "Listă Produse",
    "nav.orders": "Comandă Nouă",
    "nav.cost": "Cost",
    "nav.payments": "Plăți / Încasări",
    "nav.reports": "Rapoarte",
    "nav.assistant": "Asistent Financiar",
    "nav.import": "Actualizare Date",
    "nav.personnel": "Personal",
    "nav.audit": "Jurnal Acțiuni",
    "common.language": "Limbă",
    "common.logout": "Deconectare",
    "common.changePassword": "Schimbă Parola",
    "login.subtitle": "Conectați-vă la panoul financiar",
    "login.email": "Email",
    "login.password": "Parolă",
    "login.submit": "Autentificare",
    "login.forgot": "Ați uitat parola?",
    "login.error": "A apărut o eroare. Vă rugăm încercați din nou.",
    "dash.period": "Perioadă",
    "dash.overview": "prezentare financiară",
    "dash.netPosition": "Poziție Netă",
    "dash.bankAccounts": "conturi bancare",
    "dash.income": "Venituri",
    "dash.expense": "Cheltuieli",
    "dash.netCashflow": "Flux Net de Numerar",
    "dash.monthlyCashflow": "Flux Lunar de Numerar",
    "dash.last6": "Ultimele 6 luni · venituri / cheltuieli",
    "dash.expenseDist": "Distribuția Cheltuielilor",
    "dash.thisMonthCat": "Luna aceasta · pe categorii",
    "dash.noExpense": "Nicio cheltuială luna aceasta",
    "dash.aiTitle": "Analiză Financiară AI",
    "dash.aiSub": "Perspective bazate pe AI",
    "dash.analyze": "Analizează",
    "dash.analyzing": "Se analizează datele...",
    "dash.aiPrompt": "Apăsați \"Analizează\" pentru sugestii inteligente despre fluxul de numerar.",
    "dash.aiFail": "Analiza AI a eșuat",
    "dash.upcoming": "Plăți / Încasări Viitoare",
    "dash.pending": "operațiuni în așteptare",
    "dash.noPending": "Nicio operațiune în așteptare",
    "dash.daysLate": "zile întârziere",
    "dash.today": "Astăzi",
    "dash.daysLeft": "zile rămase",
    "dash.mamulTitle": "Panou Vânzări Produse",
    "dash.mamulSub": "Cantitate totală vândută și cifră de afaceri pe produs",
    "dash.noMamul": "Niciun produs finit cu vânzări",
    "dash.unit": "buc",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem(LANG_KEY);
    return saved && translations[saved] ? saved : "tr";
  });

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    if (translations[l]) {
      localStorage.setItem(LANG_KEY, l);
      setLangState(l);
    }
  };

  const t = (key, fallback) => translations[lang]?.[key] ?? translations.tr?.[key] ?? fallback ?? key;

  return <LanguageContext.Provider value={{ lang, setLang, t }}>{children}</LanguageContext.Provider>;
}

export const useT = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) return { lang: "tr", setLang: () => {}, t: (k, f) => translations.tr?.[k] ?? f ?? k };
  return ctx;
};
